import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ValidatorFn, AsyncValidatorFn, FormBuilder, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OperazioniDisponibili, Soggetto, FirRemoto, OutputEventCampiInit, OutputEventCampiStatus, OutputEventCampiErrors, OutputEventCampiValue } from '../../interfaces';
import { alert } from 'devextreme/ui/dialog';
import { Apiservice } from '../../../../services/api.service';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../../services/fir-digitali-transaction.service';

@Component({
  selector: 'app-dati-quantita',
  templateUrl: './dati-quantita.component.html',
  styleUrls: ['./dati-quantita.component.css']
})
export class DatiQuantitaComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() soggetto: Soggetto
  @Input() group: Array<"DatiQuantita" | "DatiQuantitaUpdate">;
  @Input() firRemoto: FirRemoto
  @Input() sezioneGroup: string
  @Input() meta: { [key: string]: boolean } = {}
  @Output() initGroup = new EventEmitter<OutputEventCampiInit>();
  @Output() statusChange = new EventEmitter<OutputEventCampiStatus>();
  @Output() errorsChange = new EventEmitter<OutputEventCampiErrors>();
  @Output() valueChange = new EventEmitter<OutputEventCampiValue>();
  protected formGroups: FormGroup = this.fb.group({})
  protected currentGroup: string = ''
  // protected isDisabled: boolean = false
  protected fields: Record<string, {
    label: string;
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();

  constructor(private readonly fb: FormBuilder, private readonly Apiservice: Apiservice, private readonly FirTransaction: FirDigitaliTransactionService) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    console.log(this)
    this.initGroup.emit({
      name: 'onInit',
      value: this.formGroups.value,
      formGroups: this.formGroups,
      sezione: this.sezioneGroup,
      component: this,
      touched: false,
    })
  }

  ngOnInit() {
    if (!this.group || !this.soggetto || !this.operazioniDisponibili || !this.firRemoto) alert('Errore', 'Attenzione');
    else {
      this.currentGroup = this.meta['DatiQuantita'] === true ? 'DatiQuantita' : 'DatiQuantitaUpdate';
      this.processFieldsMetadata();
      this.processFormGroup()
      // this.datiTipoTrasporto = this.getTipoTrasporto()

      this.formGroups.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.emitEvents());

      this.formGroups.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          const touched = this.isFormTouched()
          this.valueChange.emit({ name: 'valueChange', formGroups: this.formGroups, value: value, sezione: this.sezioneGroup, component: this, touched });
          this.emitEvents();
        });
      // this.FirTransaction.globalQueue$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: DocumentTask[]) => {
      //     this.isDisabled = next.length > 0 ? next.some((task) => (task.status !== 'error' && task.status !== 'completed') ?
      //       this.group.includes(task.processId as any) : false) : false
      //   },
      // })
      // this.FirTransaction.state$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: TransactionStateMap) => {
      //     this.isDisabled = next[this.firRemoto.dati_partenza.numero_fir] ?
      //       (next[this.firRemoto.dati_partenza.numero_fir].status !== 'error' && next[this.firRemoto.dati_partenza.numero_fir].status !== 'completed') ?
      //         next[this.firRemoto.dati_partenza.numero_fir].listTask.some((val) => (val.status !== 'completed' && val.status !== 'error') ? this.group.includes(val.processId as any) : false)
      //         : false : false
      //   },
      // })
    }
  }

  hasError(actionKey: string, fieldKey: string): boolean {
    const group = this.getForm(actionKey);
    if (!group) return false;
    const control = group.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    if (!this.isFormTouched()) return false;
    return control.invalid;
  }
  getForm(key: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    return this.formGroups.get(key) as FormGroup;
  }
  getValue(key: string, field: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    const group = this.formGroups.get(key) as FormGroup;
    const campo = group.get(field)
    if (!campo) return null
    return campo.value;
  }

  onDxChange(group, field, event) {
    const gruppo = this.formGroups.get(group)
    if (!gruppo) return
    const control = gruppo.get(field)
    if (!control) return
    control.setValue(event.value)
    gruppo.updateValueAndValidity()
  }
  //! -------------------------------------------------------------------------
  private isFormTouched(): boolean {
    const rifiuto = this.firRemoto.dati_partenza.rifiuto;
    const obj = {}
    Object.assign(obj, rifiuto)
    const normalize = (val: any): any => {
      if (val === null || val === undefined || val === '') return null;
      if (typeof val === 'object' && 'valore' in val) {
        return normalize(val.valore);
      }
      if (typeof val === 'object' && 'unita_misura' in val) {
        return normalize(val.unita_misura);
      }
      if (val instanceof Date) return val.toISOString();
      if (typeof val === 'number') return val.toString();
      return val;
    }
    const isEqual = (a: any, b: any): boolean => {
      const na = normalize(a);
      const nb = normalize(b);
      return JSON.stringify(na) === JSON.stringify(nb);
    }
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const current = group.getRawValue();

      for (const key of Object.keys(current)) {
        if (!(key in obj)) continue;

        const original = obj[key];
        const now = current[key];
        if (!isEqual(now, original)) {
          return true;
        }

      }
    }

    return false;
  }

  private emitEvents(): void {
    const messages = []
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const value = group.getRawValue();
      for (const field of Object.keys(value)) {
        const msg = this.getErrorMessage(actionKey, field);
        if (msg) messages.push(msg);
      }
    }
    const status = this.formGroups.status === 'VALID' ? 'VALID' : 'INVALID';
    const touched = this.isFormTouched()
    this.statusChange.emit({ name: 'statusChange', status, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched });
    this.errorsChange.emit({ name: 'errorsChange', errors: messages, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched });
  }

  private getErrorMessage(actionKey: string, field: string): string | null {
    const group = this.getForm(actionKey);
    const control = group.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private dynamicGroupActivation(
    validatorsMap: Record<string, ValidatorFn[]>
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!(group instanceof FormGroup)) return null;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      for (const [field, ctrl] of controls) {
        const originalValidators = validatorsMap[field] || [];
        if (hasValue) {
          ctrl.setValidators(originalValidators);
        } else {
          ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
      }
      return null;
    };
  }

  private processFormGroup() {
    for (const key of this.group) {
      const subGroup = this.fb.group({});
      this.formGroups.addControl(key, subGroup);
      this.buildQuantitaForm(subGroup, key);
    }
  }

  private buildQuantitaForm(subGroup: FormGroup, operazione: 'DatiQuantita' | 'DatiQuantitaUpdate') {
    const data = {
      quantita: 0,
      unita_misura: 'kg',
      verificato_in_partenza: false,
    }
    if (operazione === 'DatiQuantitaUpdate') {
      data.quantita = this.firRemoto.dati_partenza.rifiuto.quantita ? this.firRemoto.dati_partenza.rifiuto.quantita.valore : 0
      data.unita_misura = this.firRemoto.dati_partenza.rifiuto.quantita ? this.firRemoto.dati_partenza.rifiuto.quantita.unita_misura : 'kg'
      data.verificato_in_partenza = this.firRemoto.dati_partenza.rifiuto.verificato_in_partenza
    }
    subGroup.addControl('quantita', this.fb.control(data.quantita));
    subGroup.addControl('unita_misura', this.fb.control(data.unita_misura));
    subGroup.addControl('verificato_in_partenza', this.fb.control(data.verificato_in_partenza));
    const validatorsMap: Record<string, ValidatorFn[]> = {};
    for (const fieldName of Object.keys(subGroup.controls)) {
      validatorsMap[fieldName] = this.fields[fieldName].validators || [];
    }
    if (this.meta[operazione] === false) return;
    else return subGroup.setValidators(this.dynamicGroupActivation(validatorsMap));
  }
  private processFieldsMetadata() {
    this.fields = {
      quantita: {
        label: 'Quantità',
        validators: [Validators.required]
      },
      unita_misura: {
        label: 'Unità di Misura',
        validators: [Validators.required],
        items: {
          dataSource: [{ label: 'KG', value: 'kg' }, { label: 'L', value: 'l' }],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      },
      verificato_in_partenza: {
        label: 'Verificato',
        validators: []
      },
    }
  }

}
